export default __webpack_public_path__ + "static/media/Jill_Bucaro_AHV_In_Moms_We_Trust.985dd8c4.jpg";